import React, {useEffect, useState} from "react";
import {Grid} from "@mui/material";
import history from "../../utils/customHistory";
import SearchFilter from "./searchFilter";

const AppliedJobFilter = ({applyFilter}) => {
    const [filter, setFilter] = useState({})

    useEffect(() => {
        let initialFilter = {};
        const url = new URLSearchParams(history.location.search)
        const params = {};
        url.forEach((value, key) => {
            params[key] = value;
        })
        if (!!params.search) {
            initialFilter = {...initialFilter, search: params.search}
        }
        setFilter(initialFilter)
    }, [])

    const handlerFilterChange = (name, value) => {
        const updatedFilter = {...filter, [name]: value};
        setFilter(updatedFilter)

        const queryParamsObject = {}
        Object.keys(updatedFilter).forEach((key) => {
            switch (key) {
                case "search": {
                    if (updatedFilter[key]?.length > 3) {
                        queryParamsObject[key] = updatedFilter[key];
                    }
                    break
                }

            }

        })
        applyFilter(new URLSearchParams(queryParamsObject).toString())
    }

    return (
        <div>
            <Grid container mt={3} mb={3} spacing={2}>
                <Grid item xs={12} md={4}>
                    <SearchFilter
                        name="search"
                        selectedData={filter["search"]}
                        handleChange={(event) => handlerFilterChange("search", event?.target?.value)}
                        placeholder="Search by candidate name or email"
                    />
                </Grid>
            </Grid>
        </div>
    )
}

export default AppliedJobFilter;

